<template>
  <div>
    <v-form>
      <v-card class="d-print-none">
        <div class="pa-4">
          <v-switch
            class="mt-0"
            v-model="showRangeDate"
            :label="$t('filterByDate')"
          ></v-switch>
          <Range v-if="showRangeDate" />
          <v-autocomplete
            v-model="selectCollector"
            :items="collectors"
            solo-inverted
            placeholder="Filtrar um Arrecadador"
            item-text="nome"
            item-value="id"
            return-object
            dense
            :hint="`Id: ${selectCollector.id}`"
            persistent-hint
            prepend-icon="mdi-account-cash light-green--text"
            class="mx-2"
            clearable
          ></v-autocomplete>
        </div>
        <v-divider></v-divider>
        <v-card-actions class="py-3 px-4">
          <v-spacer></v-spacer>
          <v-btn :loading="loading" color="info" @click="cashCollector" small>
            <v-icon small left>mdi-filter</v-icon>
            {{ $t("btnFilter") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <div>
      <v-row>
        <v-col cols="12" md="8">
          <div id="print-report">
            <!-- Print Only -->
            <HeaderPrint />
            <!-- / Print Only -->

            <!-- ====================== -->
            <!-- Extrato do Arrecadador -->
            <!-- ====================== -->
            <v-card class="pa-1 pt-0 mb-3">
              <v-card-title>
                <div>
                  {{ $t("collectorExtract") }} <br />
                  <span class="caption">
                    {{ $t("collectorLabel") }}:
                    <a
                      class="light-green--text"
                      @click="
                        $profile.showProfileDrawer(
                          collector.id,
                          'regionalManager/collectors/getCollector'
                        )
                      "
                      ><v-icon color="light-green" small
                        >mdi-account-cash</v-icon
                      >
                      {{ collector.nome }}</a
                    >
                  </span>
                  <br /><span class="caption">ID: </span>
                  <v-btn @click="$copy(collector.id)" x-small>{{
                    collector.id
                  }}</v-btn>
                  <br />
                  <span class="caption"
                    >{{ $t("periodLabel") }} {{ rangeDateUi }}</span
                  >
                </div>
                <v-spacer></v-spacer>
                <div>
                  <v-btn
                    class="white black--text d-print-none"
                    :disabled="disabled"
                    small
                    @click="$print('print-report')"
                  >
                    <v-icon small left>mdi-printer</v-icon>
                    {{ $t("btnPrint") }}
                  </v-btn>
                  <v-btn
                    :disabled="disabled"
                    small
                    color="lime "
                    class="ml-3 d-print-none black--text"
                    @click="
                      [
                        $router.push({
                          name:
                            'RegionalManagerFinancialCollectorsCashCollectionRoutesToCollect',
                          params: { id_collector: collector.id },
                          query: { name_collector: collector.nome },
                        }),
                        showDialog(),
                      ]
                    "
                  >
                    <v-icon small left>mdi-routes</v-icon>
                    {{ $t("routesToCollect") }}
                  </v-btn>
                </div>
              </v-card-title>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">{{ $t("idLabel") }}</th>
                      <th class="text-left">{{ $t("date") }}</th>
                      <th class="text-left">{{ $t("categoryLabel") }}</th>
                      <th class="text-left">{{ $t("agentLabel") }}</th>
                      <th class="text-left">{{ $t("status") }}</th>
                      <th class="text-right">{{ $t("valueLabel") }}</th>
                      <th class="text-right">{{ $t("remainingBalance") }}</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr
                      v-for="item in historicDeals"
                      :key="item.data_lancamento"
                    >
                      <td class="text-left caption">
                        <v-btn @click="$copy(item.id_lancamento)" x-small>
                          {{ item.id_lancamento }}
                        </v-btn>
                      </td>
                      <td
                        class="text-left caption"
                        v-html="handlerDate(item.data_lancamento)"
                      ></td>
                      <td class="text-left caption">
                        <v-chip
                          x-small
                          :color="
                            item.categoria == '14'
                              ? 'green white--text'
                              : 'red  white--text'
                          "
                        >
                          {{ handlerCategoria(item.categoria) }}
                        </v-chip>
                      </td>
                      <td class="text-left">
                        <div
                          class="
                            d-flex
                            justify-space-between
                            align-content-start
                          "
                        >
                          <div>
                            <a
                              class="caption"
                              small
                              @click="
                                $profile.showProfileDrawer(
                                  item.id_agente,
                                  'regionalManager/agents/getAgent'
                                )
                              "
                            >
                              <v-icon color="blue" x-small>mdi-account</v-icon>
                              {{ item.nome_agente }}
                            </a>
                          </div>
                          <div>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="ml-1"
                                  icon
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="
                                    [
                                      $router.push({
                                        name:
                                          'RegionalManagerFinancialCollectorsCashCollectionExtractAgent',
                                        params: {
                                          id_agent_extract: item.id_agente,
                                        },
                                        query: {
                                          name_agent_extract: item.nome_agente,
                                          data_lancamento: item.data_lancamento,
                                        },
                                      }),
                                      showDialog(),
                                    ]
                                  "
                                >
                                  <v-icon small>mdi-receipt</v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("agentStatement") }}</span>
                            </v-tooltip>
                          </div>
                        </div>

                        <!-- <br />
                        <span class="caption">
                          <a
                            class="green--text"
                            @click="
                              $profile.showProfileDrawer(
                                item.id_local,
                                'regionalManager/locals/getLocal'
                              )
                            "
                          >
                            <v-icon color="green" x-small
                              >mdi-account-multiple</v-icon
                            >
                            {{ item.nome_local }}
                          </a>
                        </span> -->
                      </td>
                      <td
                        class="text-right caption"
                        :class="
                          item.status == '1' ? 'red--text' : 'green--text'
                        "
                      >
                        <div class="d-flex caption">
                          <v-icon
                            size="16"
                            v-if="item.status != '1'"
                            color="green"
                            >mdi-check</v-icon
                          >
                          <v-icon size="16" v-else color="red"
                            >mdi-minus</v-icon
                          >
                          {{ handlerStatus(item.status) }}
                        </div>
                      </td>
                      <td
                        class="text-right caption"
                        :class="item.valor < 0 ? 'green--text' : 'red--text'"
                      >
                        {{ handlerValor(item.valor) }}
                      </td>
                      <td
                        class="text-right caption"
                        :class="
                          item.saldo_remanescente.valor > 0
                            ? 'green--text'
                            : 'red--text'
                        "
                      >
                        {{ item.saldo_remanescente.valor }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <!-- =================== -->
            <!-- Resumo do Relatório -->
            <!-- =================== -->
            <v-card class="pa-1 pt-0">
              <v-card-title>
                <div class="subtitle-1 mb-2">
                  {{ $t("periodSummary") }}
                </div>
              </v-card-title>
              <v-simple-table>
                <template v-slot:default>
                  <tbody class="">
                    <tr>
                      <td class="text-left">
                        {{ $t("totalReceivedFromManager") }}
                      </td>
                      <td
                        class="text-right"
                        :class="
                          totalRecebidoDoGerente < 0
                            ? 'red--text'
                            : 'green--text'
                        "
                      >
                        {{ totalRecebidoDoGerente }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left">{{ $t("totalPaidToAgent") }}:</td>
                      <td
                        class="text-right"
                        :class="
                          totalPagoAosAgentes < 0 ? 'red--text' : 'green--text'
                        "
                      >
                        {{ totalPagoAosAgentes }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left">
                        {{ $t("totalReceivedFromAgent") }}:
                      </td>
                      <td
                        class="text-right"
                        :class="
                          totalRecebidoDosAgentes < 0
                            ? 'red--text'
                            : 'green--text'
                        "
                      >
                        {{ totalRecebidoDosAgentes }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-left">{{ $t("finalBalanceLabel") }}:</td>
                      <td
                        class="text-right font-weight-bold"
                        :class="saldoFinal < 0 ? 'red--text' : 'green--text'"
                      >
                        {{ saldoFinal }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :loading="loadingCosolid"
                  :disabled="!disabledConsolid"
                  class="mt-3 d-print-none"
                  color="success"
                  small
                  @click="consolid()"
                >
                  {{ $t("consolidateAndRegisterInCash") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <div id="print-cash-regional">
            <!-- =================== -->
            <!-- Caixa Regional -->
            <!-- =================== -->
            <v-card class="mb-10 pa-1 pt-0">
              <v-card-title>
                <div>
                  {{ $t("regionalFinancialBox") }} <br />
                  <span class="caption"
                    >{{ $t("collectorLabel") }}:
                    <a
                      class="light-green--text"
                      @click="
                        $profile.showProfileDrawer(
                          collector.id,
                          'regionalManager/collectors/getCollector'
                        )
                      "
                      ><v-icon color="light-green" small
                        >mdi-account-cash</v-icon
                      >
                      {{ collector.nome }}</a
                    ></span
                  >
                  <br /><span class="caption">ID: </span>
                  <v-btn @click="$copy(collector.id)" x-small>{{
                    collector.id
                  }}</v-btn>

                  <br />
                  <span class="caption">{{
                    $t("pediodAfterLastCollection")
                  }}</span>
                </div>
                <v-spacer></v-spacer>
                <div>
                  <v-btn
                    class="white black--text d-print-none"
                    :disabled="disabled"
                    small
                    @click="$print('print-cash-regional')"
                  >
                    <v-icon small left>mdi-printer</v-icon>
                    {{ $t("btnPrint") }}
                  </v-btn>
                  <v-btn
                    :disabled="disabled"
                    small
                    color="info"
                    class="ml-3 d-print-none"
                    @click="
                      [
                        $router.push({
                          name:
                            'RegionalManagerFinancialCollectorsCashCollectionSetCash',
                          params: { id_collector: collector.id },
                          query: { name_collector: collector.nome },
                        }),
                        showDialog(),
                      ]
                    "
                    >{{ $t("newLaunch") }}</v-btn
                  >
                </div>
              </v-card-title>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">{{ $t("date") }}</th>
                      <th class="text-left">{{ $t("idLabel") }}</th>
                      <th class="text-left">{{ $t("categoryLabel") }}</th>
                      <!-- <th class="text-left">Arrecadador</th> -->
                      <th class="text-right">{{ $t("valueLabel") }}</th>
                    </tr>
                  </thead>
                  <tbody class="">
                    <tr v-for="item in cashEntrys" :key="item.data_lancamento">
                      <td
                        class="text-left caption"
                        v-html="handlerDate(item.data_registro)"
                      ></td>
                      <td class="text-left caption">
                        <v-btn @click="$copy(item.id_lancamento)" x-small>
                          {{ item.id_lancamento }}
                        </v-btn>
                      </td>
                      <td class="text-left caption">
                        {{ handlerCategoriaEntrys(item.categoria) }}
                      </td>
                      <!-- <td class="text-left caption">
                        <a
                          class="light-green--text"
                          @click="
                            $profile.showProfileDrawer(
                              collector.id,
                              'regionalManager/collectors/getCollector'
                            )
                          "
                          ><v-icon color="light-green" small
                            >mdi-account-cash</v-icon
                          >
                          {{ item.nome_arrecadador }}</a
                        >
                      </td> -->
                      <td
                        class="text-right caption"
                        :class="item.valor < 0 ? 'red--text' : 'green--text'"
                      >
                        {{ item.valor }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import Range from "@/components/common/filters/Range";
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "regional-manager-financial-regional-cash-collection",
  components: {
    Range,
    HeaderPrint,
  },
  data: () => ({
    showRangeDate: "",
    disabled: true,
    loading: false,
    loadingCosolid: false,
    selectCollector: { id: "", nome: "" },
    collectors: [],
    historicDeals: [],
    cashEntrys: [],
    totalRecebidoDoGerente: "",
    totalPagoAosAgentes: "",
    totalRecebidoDosAgentes: "",
    saldoFinal: "",
    rangeDateConsolid: "",
    rangeDateUi: "",
    collector: "",
  }),
  async mounted() {
    this.showRangeDate = false;
    const result = await this.$request.get("regionalManager/collectors/list");
    if (result == undefined) return;
    this.collectors = result.dados;
    // reset Range
    this.$store.commit("SetRangeDate", {});

    if (this.$route.params.id_collector) {
      this.selectCollector.id = this.$route.params.id_collector;
      this.selectCollector.nome = this.$route.query.name_collector;
      this.cashCollector();
    }
  },
  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    // Disanble button Consolid
    disabledConsolid() {
      return this.historicDeals.some((element) => element.status == "1");
    },
  },
  watch: {
    showRangeDate(val) {
      if (val === false) {
        this.$store.commit("SetRangeDate", {});
      }
    },
    refresh(val) {
      val && this.cashCollector();
      this.$store.commit("setRefresh", false);
    },
  },
  methods: {
    // Filter Collector
    cashCollector: async function() {
      this.loading = true;
      this.disabled = true;

      const body = {
        ...this.rangeDate,
        id_collector: this.selectCollector.id,
      };

      const result = await this.$request.post(
        "regionalManager/financial/cashCollector",
        body
      );

      this.loading = false;
      this.resetReports();
      if (result.length == 0) return;
      this.disabled = false;
      this.collector = result.collector;
      this.buildRangeDate(result.data_inicio, result.data_final);
      this.buildReports(result.historicDeals, result.cashEntrys);
    },

    // Build Range Date
    buildRangeDate(start, end) {
      // Store range date to consolidation
      this.rangeDateConsolid = {
        data_inicio: start,
        data_final: end,
      };
      // Handler Range date UI
      const dateStart = new Date(start.replace(" ", "T")).toLocaleString();
      const dateEnd = new Date(end.replace(" ", "T")).toLocaleString();
      this.rangeDateUi = `${dateStart} ${dateEnd}`;
    },

    // Reset Reports
    resetReports() {
      this.historicDeals = [];
      this.cashEntrys = [];
      this.totalRecebidoDoGerente = "";
      this.totalPagoAosAgentes = "";
      this.totalRecebidoDosAgentes = "";
      this.saldoFinal = "";
    },

    // Build Reports
    buildReports(historicDeals, cashEntrys) {
      let historic = [];

      // Tratando o array para incluir o saldo remanescente
      historicDeals.forEach((item) => {
        if (item.categoria == "15" || item.categoria == "14") {
          historic.push(item);
        }

        if (item.categoria == "20") {
          historic.forEach((launch) => {
            if (
              item.data_lancamento == launch.data_lancamento &&
              item.id_agente == launch.id_agente
            ) {
              launch.saldo_remanescente = item;
            }
          });
        }
      });

      this.historicDeals = historic;
      this.cashEntrys = cashEntrys;

      let sum = {
        recebidoGerente: 0,
        pagoAgente: 0,
        recebidoAgente: 0,
      };

      cashEntrys.forEach((element) => {
        // Soma Depósito ao Agente
        if (element.categoria != 1) {
          sum.recebidoGerente += Number(element.valor);
        }
      });

      this.historicDeals.forEach((element) => {
        // Soma Recebido do Agente
        if (element.categoria == "14" && element.status == 1) {
          sum.recebidoAgente += Number(element.valor);
        }

        // Soma Pago do Agente
        if (element.categoria == "15" && element.status == 1) {
          sum.pagoAgente += Number(element.valor);
        }
      });

      this.totalRecebidoDoGerente = this.decimalAdjustment(
        sum.recebidoGerente * -1
      );
      this.totalPagoAosAgentes = this.decimalAdjustment(sum.pagoAgente * -1);
      this.totalRecebidoDosAgentes = this.decimalAdjustment(
        sum.recebidoAgente * -1
      );
      this.saldoFinal = this.decimalAdjustment(
        this.totalRecebidoDoGerente +
          this.totalPagoAosAgentes +
          this.totalRecebidoDosAgentes
      );
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },

    handlerDate: function(val) {
      const date = new Date(val.replace(" ", "T")).toLocaleDateString();
      const time = new Date(val.replace(" ", "T")).toLocaleTimeString();
      return `${date} <br> ${time}`;
    },

    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },

    async consolid() {
      this.loadingCosolid = true;

      const body = {
        ...this.rangeDateConsolid,
        id_collector: this.selectCollector.id,
        value: this.saldoFinal,
      };

      const result = await this.$request.post(
        "regionalManager/financial/consolidateCash",
        body
      );

      this.loadingCosolid = false;
      if (result.length == 0) return;
      // refresh page
      this.cashCollector();
    },
    handlerCategoria(item) {
      if (item == "14") return this.$t("receivedLabel");
      if (item == "15") return this.$t("paidLabelCollector");
    },
    handlerValor: function(val) {
      return val * -1;
    },
    handlerStatus: function(val) {
      if (val == "1") return this.$t("notConsolidated");
      return this.$t("isConsolidated");
    },
    handlerCategoriaEntrys: function(val) {
      if (val == "1") return this.$t("lastPickup");
      if (val == "2") return this.$t("prizeDepositPayment");
      if (val == "3") return this.$t("miscellaneousDeposit");
      if (val == "4") return this.$t("chargeback");
    },
  },
};
</script>
